<template>
  <div class="register-page" v-slideIn>
    <div class="page-head-container">
      <PageHead pageName="注册" />
    </div>
    <div class="steps-container">
      <Steps :current="1" />
    </div>

    <div class="form-area">
      <div>
        <Input
          placeholder="手机号"
          name="phone"
          v-model="phone"
          :error="phoneError"
          @input="handlePhoneInput"
        />
      </div>
      <verification-code
        :error="randCodeError"
        @blur="handleRandCodeBlur"
        @updateKey="handleRandomCode"
        v-model="randCode"
      />
      <div>
        <Input
          ref="smsCodeInput"
          placeholder="短信验证码"
          name="smsCode"
          v-model="smsCode"
          :error="smsCodeError"
          @input="handleSmsCodeInput"
        />
        <span class="get-smscode">
          <Countdown :onClick="handleSmsCodeClick" text="获取验证码" />
        </span>
      </div>
      <div>
        <Input
          :type="passwordInputType"
          placeholder="密码"
          name="password"
          v-model="password"
          :error="passwordError"
          @input="handlePasswordInput"
        />
        <img
          :src="showPassword ? visibleImg : invisibleImg"
          @click="handleEyeClick"
          class="eye-img"
        />
      </div>
      <div>
        <Input
          type="password"
          placeholder="重复密码"
          name="repeatPassword"
          v-model="repeatPassword"
          :error="repeatPasswordError"
          @input="handleRepeatPasswordInput"
          @keyup="handleLastInputKeyUp"
        />
      </div>
      <div class="accept">
        <input
          type="checkbox"
          :checked="accept"
          name="accept"
          @change="handleAcceptChange"
        />
        <label for="accept">
          同意并遵守
          <span @click="showProtocol = true" class="protocol-link">《注册协议》</span>
        </label>
      </div>
      <div class="button">
        <Button text="注册" type="success" :onClick="handleRegister"></Button>
      </div>
      <div class="button">
        <Button text="返回登录" :onClick="goToLogin"></Button>
      </div>
    </div>

    <div class="operate-container">
      <div class="intro">为工业4.0而生</div>
    </div>

    <Modal
      title="注册协议"
      :visible.sync="showProtocol"
      :onOk="handleContinue"
      text="同意并继续"
    >
      <iframe
        style="width: 100%; height: 100%"
        :src="registerAgreement"
        frameborder="0"
      ></iframe>
    </Modal>
  </div>
</template>
<script>
import Steps from '@/components/Steps/index.vue';
import PageHead from '@/components/PageHead/index.vue';
import Input from '@/components/Input/index.vue';
import Button from '@/components/Button/index.vue';
import Countdown from '@/components/Countdown/index.vue';
import api from '@/api';
import Message from '@/components/Message';
import Modal from '@/components/Modal/index.vue';
import session from '@/utils/session';
import VerificationCode from '@/components/VerificationCode';
import visibleImg from '@/assets/visible.png';
import invisibleImg from '@/assets/invisible.png';

import env from '@/utils/env';
import { routes } from '@/config';
import { setCookie } from '@/utils/cookie';

export default {
  name: 'sso-register',
  data() {
    return {
      registerAgreement: '',
      visibleImg,
      invisibleImg,
      showPassword: false,
      passwordInputType: 'password',
      phone: '',
      smsCode: '',
      randCode: '',
      randomCodeKey: '',
      randCodeError: '',
      password: '',
      repeatPassword: '',
      email: '',
      accept: false,

      phoneError: '',
      smsCodeError: '',
      passwordError: '',
      repeatPasswordError: '',
      emailError: '',

      showProtocol: false,
    };
  },
  created() {
    // 如果没有平台代码则默认使用交易的平台代码
    if (!this.$route.query.platform_code) {
      this.$router.push({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          platform_code: 'trade',
        },
      });
    }
    this.initial();
  },
  methods: {
    initial() {
      setTimeout(() => {
        this.registerAgreement =
          JSON.parse(localStorage.getItem('WEB_INFO')).init.registerAgreement || '';
        let baseTitle = JSON.parse(localStorage.getItem('WEB_INFO')).title || '';
        document.title = `${baseTitle}注册`;
      }, 500);
    },
    handleContinue() {
      this.accept = true;
    },
    validatePhone() {
      let errorText = '';
      if (!this.phone) {
        errorText = '请输入手机号';
      } else if (!/^1[\d]{10}$/.test(this.phone)) {
        errorText = '手机号格式错误';
      }
      this.phoneError = errorText;
      return !errorText;
    },
    handlePhoneInput(v) {
      this.validatePhone();
    },
    validateSmsCode() {
      let errorText = '';
      if (!this.smsCode) {
        errorText = '请输入短信验证码';
      } else if (!/^[\d]{4}$/.test(this.smsCode)) {
        errorText = '短信验证码格式错误';
      }
      this.smsCodeError = errorText;
      return !errorText;
    },
    handleSmsCodeInput(v) {
      this.validateSmsCode();
    },
    validatePassword() {
      let reg = /^(?:(?=.*[A-Z])(?=.*[0-9]))[a-zA-Z0-9]{6,12}$/;
      let errorText = '';
      if (!this.password) {
        errorText = '请输入密码';
      } else if (!reg.test(this.password)) {
        errorText = '6-12位数字字母组合，必须包含大写字母';
      }
      this.passwordError = errorText;
      return !errorText;
    },
    handlePasswordInput(v) {
      this.validatePassword();
    },
    validateRepeatPassword() {
      let errorText = '';
      if (!this.repeatPassword) {
        errorText = '两次密码输入不一致，请重新输入';
      }
      if (this.repeatPassword !== this.password) {
        errorText = '两次密码输入不一致，请重新输入';
      }
      this.repeatPasswordError = errorText;
      return !errorText;
    },
    validateEmail() {
      let errorText = '';
      if (!this.email) {
        errorText = '请输入邮箱';
      }
      if (!/\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/.test(this.email)) {
        errorText = '请输入正确格式的邮箱';
      }
      this.emailError = errorText;
      return !errorText;
    },
    handleRepeatPasswordInput(v) {
      this.validateRepeatPassword();
    },
    handleEmailInput(v) {
      this.validateEmail();
    },
    handleLastInputKeyUp(e) {
      if (e.keyCode === 13) {
        this.handleRegister();
      }
    },
    goToLogin() {
      this.$router.push({
        path: routes.login,
        query: { ...this.$route.query },
      });
    },
    handleAcceptChange(e) {
      let v = e.target.checked;
      this.accept = v;
    },
    handleEyeClick() {
      this.showPassword = !this.showPassword;
      if (this.showPassword) {
        this.passwordInputType = 'text';
      } else {
        this.passwordInputType = 'password';
      }
    },
    validate() {
      return (
        this.validatePhone() &&
        this.validateSmsCode() &&
        this.validatePassword() &&
        this.validateRepeatPassword() &&
        !this.getRandCodeErrorInfo(this.randCode)
      );
    },
    handleRegister() {
      if (!this.validate()) {
        return;
      }
      if (!this.accept) {
        Message.warning('请阅读会员注册协议并同意遵守');
        return;
      }
      api
        .register({
          phone: this.phone,
          phoneCode: this.smsCode,
          password: this.password,
          email: this.email,
          platformCode: this.$route.query.platform_code,
        })
        .then((res) => {
          if (res.code === 0) {
            let ticket = res.data.ticket;

            session.saveTicket(ticket);
            this.getToken(ticket).then((resp) => {
              this.loginSuccess(resp);
            });
          }
        });
    },
    getToken(ticket) {
      return api.getToken(ticket, {
        serviceURL:
          this.$route.query.redirect_url ||
          this.$route.query.serviceURL ||
          location.href,
      });
    },
    loginSuccess(resp) {
      if (resp.code === 0) {
        let token = resp.data.token || resp.data;
        const rootDomain = env.getRootDomain();
        session.saveToken(token);
        // 设置一个SHARE_BY_SSO到根域名的cookie，防止uamsdk将token清除
        setCookie(
          'SHARE_BY_SSO',
          Math.random().toString(16).substr(2) + '_session_state',
          0,
          '/',
          rootDomain
        );

        Message.success('注册成功,请完善相关资质');
        this.$router.push({
          path: routes.chooseService,
          query: { ...this.$route.query },
        });
      }
    },
    doesUserExist() {
      let params = {
        phone: this.phone,
        noParamsKey: true,
      };
      return api.doesUserExist(params);
    },
    getRandCodeErrorInfo(value) {
      if (value) {
        return value.length < 4 ? '图片验证码格式不正确' : '';
      } else {
        return '请输入图片验证码';
      }
    },
    handleRandCodeBlur(value) {
      this.randCodeError = this.getRandCodeErrorInfo(value);
    },
    handleRandomCode(key) {
      this.randomCodeKey = key;
    },
    handleSmsCodeClick() {
      if (!this.phone) {
        this.phoneError = '请输入手机号';
        return;
      }
      if (this.getRandCodeErrorInfo(this.randCode)) {
        this.randCodeError = this.getRandCodeErrorInfo(this.randCode);
        return;
      }
      return this.doesUserExist().then((res) => {
        if (res.code !== 0) {
          return res;
        }
        if (res.data) {
          res.code = 2000;
          this.phoneError = '该手机号已注册';
        } else {
          this.getSmsCode();
        }
        return res;
      });
    },
    getSmsCode() {
      if (!this.validatePhone()) {
        return;
      }
      return api
        .getRegisterSmsCode({
          phone: this.phone,
          key: this.randomCodeKey,
          randCode: this.randCode,
        })
        .then((res) => {
          if (res.code === 0) {
            // this.$refs.smsCodeInput.focus()
          }
          return res;
        });
    },
  },
  components: {
    Input,
    Button,
    Countdown,
    Steps,
    PageHead,
    Modal,
    VerificationCode,
  },
};
</script>
<style lang="scss" scoped>
@import './style.scss';
</style>
